import { SvgIcon, SvgIconProps } from '@mui/material';

const VisibilityOff = ({
  viewBox = '0 0 24 24',
  sx,
  ...props
}: SvgIconProps) => (
  <SvgIcon
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    sx={{ width: 24, height: 24, fill: 'none', ...sx }}
    data-testid="visibilityOffIcon"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.57535 4.57544L3.16113 5.98965L5.46592 8.29444C3.53239 10.1102 2.25 12.0001 2.25 12.0001C2.25 12.0001 7 19.0001 12 19.0001C13.1208 19.0001 14.229 18.6483 15.274 18.1025L18.0104 20.8389L19.4246 19.4247L17.001 17.0011C17.001 17.0011 17.001 17.001 17.001 17.0011L15.5356 15.5356C15.5356 15.5355 15.5355 15.5356 15.5356 15.5356L14.1213 14.1214C14.1213 14.1214 14.1213 14.1214 14.1213 14.1214L9.87871 9.87871C9.87873 9.87869 9.8787 9.87872 9.87871 9.87871L8.46445 8.46454C8.46443 8.46456 8.46447 8.46453 8.46445 8.46454L6.99905 6.99904C6.99907 6.99903 6.99903 6.99906 6.99905 6.99904L4.57535 4.57544ZM7.34437 10.1729C7.12207 10.7389 7 11.3552 7 12.0001C7 14.7615 9.23858 17.0001 12 17.0001C12.6448 17.0001 13.2612 16.878 13.8272 16.6557L12.167 14.9955C12.1117 14.9985 12.056 15.0001 12 15.0001C10.3431 15.0001 9 13.6569 9 12.0001C9 11.944 9.00154 11.8884 9.00457 11.8331L7.34437 10.1729Z"
      fill="#373B49"
    />
    <path
      d="M17 12.0001C17 12.6449 16.8779 13.2612 16.6556 13.8272L18.5341 15.7057C20.4676 13.8899 21.75 12.0001 21.75 12.0001C21.75 12.0001 17 5.00006 12 5.00006C10.8792 5.00006 9.77098 5.35179 8.72599 5.89756L10.1729 7.34442C10.7388 7.12213 11.3552 7.00006 12 7.00006C14.7614 7.00006 17 9.23864 17 12.0001Z"
      fill="#373B49"
    />
    <path
      d="M14.9954 12.167L11.8331 9.00463C11.8883 9.0016 11.944 9.00006 12 9.00006C13.6569 9.00006 15 10.3432 15 12.0001C15 12.0561 14.9985 12.1117 14.9954 12.167Z"
      fill="#373B49"
    />
  </SvgIcon>
);

export default VisibilityOff;
